import { Component, OnInit } from '@angular/core';
import { TrackRender } from 'app/shared/front-perfomance';

@TrackRender()
@Component({
    selector: 'app-pagenotauthorized',
    templateUrl: './pagenotauthorized.component.html',
    styleUrls: ['./pagenotauthorized.component.scss'],
    standalone: false
})
export class PagenotauthorizedComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
